<template>
  <div
    v-if="
      (priceDatas && priceDatas.vipPrice >= 0) ||
        (priceDatas && priceDatas.vipPrice && priceDatas.vipPrice.length)
    "
  >
    <div v-if="showType == 0" class="price-container showTypeone">
      <div class="vip-mark" style="margin-left:0;">{{ priceDatas.mark }}</div>
      <div class="text">{{ priceDatas.vipPrice }}</div>
      <div v-if="priceDatas.type == 1" class="icon"></div>
      <div v-else class="min-icon"></div>
    </div>
    <div v-else-if="showType == 1" class="price-container list">
      <div class="price">
        <div class="mark">{{ priceDatas.mark }}</div>
        <div class="origin-price">{{ priceDatas.sellPrice }}</div>
      </div>
      <div class="vip-price">
        <div class="vip-mark">{{ priceDatas.mark }}</div>
        <div class="text">{{ priceDatas.vipPrice }}</div>
        <div v-if="priceDatas.type == 1" class="icon"></div>
        <div v-else class="min-icon"></div>
      </div>
    </div>
    <div v-else class="price-container">
      <div class="vip-mark vipmarklast">{{ priceDatas.mark }}</div>
      <div class="text">{{ priceDatas.vipPrice }}</div>
      <div v-if="priceDatas.type == 1" class="icon"></div>
      <div v-else class="min-icon"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showType: {
      type: Number,
      default: 2,
    },
    priceData: {
      type: Object,
    },
  },
  data() {
    return {
      priceDatas: {
        mark: '¥',
        price: 0,
        type: 1,
      },
    };
  },
  created() {
    this.priceDataUp(this.priceData);
  },
  methods: {
    priceDataUp(priceData) {
      if (priceData) {
        let minPrice = priceData.minPrice || '';
        let maxPrice = priceData.maxPrice || '';
        let sellPrice = priceData.sellPrice || '';
        if (!sellPrice) {
          sellPrice = this.priceComputed(minPrice, maxPrice);
        }
        this.priceDatas = this.priceData;
        this.priceDatas.sellPrice = sellPrice;
      }
    },

    priceComputed(priceLow, priceHigh) {
      if (priceLow && priceHigh) {
        if (priceLow === priceHigh) {
          return '¥ ' + priceHigh;
        }
        return '¥ ' + priceLow + '-' + priceHigh;
      } else if (priceLow) {
        return '¥ ' + priceLow;
      } else if (priceHigh) {
        return '¥ ' + priceHigh;
      } else {
        return '免费';
      }
    },
  },
};
</script>
<style scoped>
.price-container {
  display: flex;
  align-items: flex-end;
  font-family: DIN-Medium, PingFangSC-Medium;
  font-weight: 500;
}
.showTypeone {
  margin-top: 0.07rem;
}

.price-container.list {
  display: inline;
}

.list .price {
  display: flex;
  align-items: flex-end;
}
.list .price .origin-price {
  font-size: 0.16rem;
  line-height: 0.16rem;
}
.list .vip-price {
  display: flex;
  align-items: flex-end;
  margin-top: 0.06rem;
  font-size: 0.13rem;
}
.list .price .mark {
  font-size: 0.13rem;
}

.price-container .text {
  font-size: 0.13rem;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
  line-height: 0.13rem;
  margin-right: 0.08rem;
}

.price-container .icon {
  width: 0.35rem;
  height: 0.13rem;
  background: url(https://img.zai-art.com/zaiart/cms/image/64b1fea296dbcb807a6469001224ee9f.png)
    no-repeat;
  background-size: 0.35rem 0.13rem;
  border-radius: 0.01rem;
  overflow: hidden;
}

.price-container .min-icon {
  width: 0.44rem;
  height: 0.13rem;
  background: url(https://img.zai-art.com/zaiart/cms/image/d8c135b24052c810770532b3af9edad9.png)
    no-repeat;
  background-size: 0.44rem 0.13rem;
  border-radius: 0.01rem;
  overflow: hidden;
}

.price-container .mark {
  font-size: 0.13rem;
  color: #ff3e3e;
  line-height: 0.13rem;
  margin-right: 0.025rem;
}

.price-container .vip-mark {
  font-size: 0.13rem;
  color: rgba(34, 34, 34, 1);
  line-height: 0.13rem;
  margin-right: 0.025rem;
}
.price-container .vip-mark.vipmarklast {
  margin-left: 0.15rem;
}
.price-container .origin-price {
  font-size: 0.2rem;
  line-height: 0.2rem;
  color: #ff3e3e;
}
</style>
